// extracted by mini-css-extract-plugin
export default {"about":"About_about__q8A8w","about__title":"About_about__title__TxIFN","about__block":"About_about__block__fY2Ko","about__girl-img":"About_about__girl-img__D1RC9"};